import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { verifyAffiliateCode } from "../hooks/useAffiliateCode";

const PricePlanAffiliate = () => {
  const navigate = useNavigate();
  const { affiliateCode } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const normalizedCode = affiliateCode?.trim()?.toUpperCase();
    const queryString = searchParams.toString();
    const redirectTarget = queryString ? `/?${queryString}` : "/";

    if (!normalizedCode || normalizedCode.length <= 4) {
      navigate(redirectTarget);
      return;
    }

    const verifyAndRedirect = async () => {
      localStorage.removeItem("deliva_affiliate_code");
      const result = await verifyAffiliateCode(normalizedCode);
      if (result.isValid) {
        localStorage.setItem("deliva_affiliate_code", normalizedCode);
      }
      navigate(redirectTarget);
    };

    verifyAndRedirect();
  }, [affiliateCode]);

  return null;
};

export default PricePlanAffiliate;
